module.exports = __webpack_public_path__ + "static/img/KALANI-WHITE.545236e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/KALANI-WHITE.jpg
// module id = Z0Cw
// module chunks = 0